export default __webpack_public_path__ + "static/media/toggleOffIcon.4cb9bc75.svg";